export class AccessProHelpModal {
    constructor({ id, title, contentHTML, titleTranslationKey }) {
        this.id = id;
        this.title = title;
        this.titleTranslationKey = titleTranslationKey;
        this.contentHTML = contentHTML;
        this.overlay = null;
        this.modal = null;
        this.closeButton = null;
        this.previousActiveElement = null;
        this._init();
    }

    _init() {
        // Only create if not already present
        let overlay = document.getElementById(this.id);
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'acp-help-modal-overlay';
            overlay.id = this.id;
            overlay.innerHTML = `
          <div class="acp-help-modal" role="dialog" aria-labelledby="${this.id}-title" aria-modal="true">
            <div class="acp-help-modal-header">
              <h2 id="${this.id}-title" ${this.titleTranslationKey ? `data-ap-translate="${this.titleTranslationKey}"` : ''}>${this.title}</h2>
              <div role="button" tabindex="0" class="acp-help-modal-close" aria-label="Close help dialog">
                ${ACCESSPRO_ICONS.xMark}
                <span class="sr-only">Close</span>
              </div>
            </div>
            <div class="acp-help-modal-content">
              ${this.contentHTML}
            </div>
          </div>
        `;
            document.body.appendChild(overlay);
        }
        this.overlay = overlay;
        this.modal = overlay.querySelector('.acp-help-modal');
        this.closeButton = overlay.querySelector('.acp-help-modal-close');
        this._setupEvents();
    }

    _setupEvents() {
        // Trap focus
        const focusableElements = this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];
        const trapFocus = (e) => {
            if (e.key === 'Tab') {
                if (e.shiftKey && document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                } else if (!e.shiftKey && document.activeElement === lastFocusable) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape') this.close();
        };
        this._trapFocus = trapFocus;
        this._handleEscape = handleEscape;
        this.closeButton.addEventListener('click', () => this.close());
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) this.close();
        });
        this._focusableElements = focusableElements;
        this._firstFocusable = firstFocusable;
    }

    show() {
        this.overlay.classList.add('visible');
        this.previousActiveElement = document.activeElement;
        this._firstFocusable.focus();
        this.modal.addEventListener('keydown', this._trapFocus);
        document.addEventListener('keydown', this._handleEscape);
    }

    close() {
        this.overlay.classList.remove('visible');
        this.previousActiveElement?.focus();
        this.modal.removeEventListener('keydown', this._trapFocus);
        document.removeEventListener('keydown', this._handleEscape);
    }
}
